<template>
    <footer class="foot">
        <nav>
            <ul>
                <li><a href="Conditions.pdf" target="_blank">Terms and Conditions</a></li>
                <li><a href="https://uk.rs-online.com/web/generalDisplay.html?id=aboutRS/privacy-policy" target="_blank">Privacy Policy</a></li>
            </ul>
        </nav>
    </footer>
</template>
<script>
export default {
    name: 'AppSiteFooter'
}
</script>
<style scoped>

</style>